import React, { Component } from "react";
import { OrbitSpinner } from "react-epic-spinners";
import CustomerVehiclePlateCode from "../views/customer-vehicles/customer-vehicle-platecode";
import { CustomerVehicleEnergy } from "../views/customer-vehicles/customer-vehicle-energy";
import strings from "./translate";
import SocketEngine from "./SocketEngine";

class CoreEngine extends Component {
  /**
   * Sends a signed out visitor back to the login screen.
   *
   * This ran in componentWillMount, which React deprecated. It cannot move to
   * componentDidMount: nearly every screen defines its own, which would
   * override this one and drop the check. The constructor runs for every
   * subclass through super(), so the guard stays in place.
   */
  constructor(props) {
    super(props);
    const isloggedin = sessionStorage.getItem("isloggedin");
    if (!isloggedin || isloggedin === "false") {
      // forms rendered inside a dialog get no router props of their own
      if (props && props.history) {
        props.history.push("/auth/login");
      }
    } else {
      // Idempotent — every screen mount runs this, but connect() reuses an
      // already-open socket instead of opening a new one each time.
      SocketEngine.connect();
    }
  }

   hasPermission = (requiredScopes) => {
    const userScopesString = sessionStorage.getItem("scopes") || "";
    const userScopes = userScopesString.split(",").map((scope) => scope.trim());
    return requiredScopes.some((scope) => userScopes.includes(scope.toLowerCase()));
  };

  fetchmakes = async () => {
    const response = await this.engine.getItem("vehicles");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        makes: response.data.items.map((make) => ({
          value: make.id,
          label: make.name,
        })),
      });
    }
  };

  async fetchmodels() {
    const { selectedMake, selectedModel } = this.state;
    if (!selectedMake) return;
    const response = await this.engine.getItem(
      `vehicles/${selectedMake}/models`
    );
    if (response && response.status === 200) {
      if (selectedModel !== ":selectedModel")
        this.setState({
          models: response.data.items.map((model) => ({
            value: model.id,
            label: model.name,
          })),
        });
      else
        this.setState({
          models: response.data.items.map((model) => ({
            value: model.id,
            label: model.name,
          })),
          selectedModel: "",
        });
    }
  }

  async fetchtrims() {
    const { selectedModel, trimId } = this.state;
    if (!selectedModel) return;
    const response = await this.engine.getItem(
      `vehicles-models/${selectedModel}/trims`
    );
    if (response && response.status === 200) {
      if (trimId !== ":trimId")
        this.setState({
          trims: response.data.items.map((trim) => ({
            value: trim.id,
            label: trim.name,
          })),
        });
      else
        this.setState({
          trims: response.data.items.map((trim) => ({
            value: trim.id,
            label: trim.name,
          })),
          trimId: "",
        });
    }
  }
  handleMakeSelect = (event) => {
    const selectedMake = event.value;
    if (selectedMake !== this.state.selectedMake)
      this.setState({ selectedMake, selectedModel: "", models: [] }, () => {
        this.fetchmodels();
      });
  };

  handleModelSelect = (event) => {
    const selectedModel = event.value;
    this.setState({ selectedModel }, () => {
      this.fetchtrims();
    });
  };

  handleTrimSelect = (event) => {
    const trimId = event.value;
    this.setState({ trimId, isTrimSelected: true });
  };

  fetchCodes() {
    const plateCodeOptions = Object.values(CustomerVehiclePlateCode).map(
      (code) => ({
        value: code,
        label: code,
      })
    );
    this.setState({
      plateCodeOptions,
    });
  }

  fetchEnergyOptions() {
    const energyOptions = Object.values(CustomerVehicleEnergy).map(
      (energy) => ({
        value: energy,
        label: strings[energy.toLowerCase()],
      })
    );
    this.setState({
      energyOptions,
    });
  }

  putrowstatus(item) {
    if (item.status === 0) {
      return "Pending";
    } else if (item.status === 1) {
      return "Activated";
    }
  }

  changeInput = (event, stateName) => {
    let newValue;
    if (!event) {
      newValue = "";
    } else if (event && event.target) {
      newValue = event.target.value;
    } else if (event && event.length) {
      newValue = event;
    } else {
      newValue = event.value; // select input
    }

    const trimmedValue =
      typeof newValue === "string" ? newValue.trim() : newValue;
    this.setState({ [stateName]: trimmedValue });
  };

  changeInputOne = (event, stateName) => {
    if (!event) {
      this.setState({ [stateName]: "" });
    } else if (event && event.target) {
      this.setState({ [stateName]: event.target.value });
    } else {
      this.setState({ [stateName]: event.value }); // select input
    }
  };

  convertToSlug(Text, slug = "-") {
    return Text.trim()
      .toLowerCase()
      .replace(/[^\w ]+/g, "")
      .replace(/ +/g, slug);
  }
  createSelectValue(array, withslug = false) {
    let data = [];
    array.map((item) => {
      if (item.length < 2) {
      } else {
        if (withslug) {
          data.push({
            value: this.convertToSlug(item, "xx"),
            label: item.trim(),
          });
        } else {
          data.push({
            value: item.trim().toLowerCase(),
            label: item.trim().toLowerCase(),
          });
        }
      }
    });
    return data;
  }

  formatDate = (date) => {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  filterCaseInsensitive(filter, row) {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined
      ? String(row[id].toString().toLowerCase()).includes(
          filter.value.toString().toLowerCase()
        )
      : true;
  }

  renderDateFromTimeStamp(timestamp) {
    let moment = require("moment");
    const formatted = moment.unix(timestamp / 1000).format("DD/MM/YYYY HH:mm");
    return <span>{formatted}</span>;
  }

  renderDateForEdit(date) {
    let moment = require("moment");
    const formatted = moment(date).format("YYYY-MM-DD");
    return formatted;
  }

  renderDate(item) {
    if (!item) {
      return "-";
    }
    let moment = require("moment");

    let obj = moment(item).utcOffset(item);

    // const newdate = obj.format('DD/MM/YYYY HH:mm')
    const newdate = obj.format("DD/MM/YYYY ");
    return newdate;
  }

  renderProgress() {
    return (
      <div className="content">
        <div className="col-md-2 ml-auto mr-auto">
          <div className="logo">
            <div className="logo-img">
              <OrbitSpinner color="#51BCDA" className="loadingLogo" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CoreEngine;
